import { render, staticRenderFns } from "./PapaSummaryView.vue?vue&type=template&id=3db924b0&scoped=true&"
import script from "./PapaSummaryView.vue?vue&type=script&lang=ts&"
export * from "./PapaSummaryView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db924b0",
  null
  
)

export default component.exports